import React, { useEffect, useState } from 'react';
import { Search as SearchIcon, Loader2 } from 'lucide-react';
import Navbar from '../components/Navbar';
import MovieModal from '../components/MovieModal';
import SponsorshipBanner from '../components/SponsorshipBanner';
import { searchMulti, IMG_W500, IMG_BASE } from '../utils/tmdb';

const Search = () => {
  const [q, setQ] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    const t = setTimeout(async () => {
      if (!q.trim()) {
        setResults([]);
        return;
      }
      setLoading(true);
      try {
        const r = await searchMulti(q);
        setResults(r);
      } finally {
        setLoading(false);
      }
    }, 350);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div className="bg-[#141414] min-h-screen text-white">
      <Navbar />
      <div className="pt-28 px-4 md:px-14 pb-16">
        <div className="max-w-3xl mx-auto">
          <div className="flex items-center gap-3 bg-[#1a1a1a] border border-white/10 rounded-md px-4 py-3">
            <SearchIcon className="w-5 h-5 text-white/50" />
            <input
              autoFocus
              type="text"
              placeholder="Search movies, TV shows..."
              value={q}
              onChange={(e) => setQ(e.target.value)}
              className="flex-1 bg-transparent outline-none placeholder-white/40 text-base"
            />
            {loading && <Loader2 className="w-4 h-4 animate-spin text-white/50" />}
          </div>
        </div>

        {!q.trim() && (
          <div className="mt-8 -mx-4 md:-mx-14">
            <SponsorshipBanner placement="search_top" />
          </div>
        )}

        <div className="mt-10 max-w-6xl mx-auto">
          {q.trim() && !loading && results.length === 0 && (
            <p className="text-white/60 text-center py-16">No results for “{q}”.</p>
          )}

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
            {results.map((r) => {
              const src = r.poster_path ? `${IMG_W500}${r.poster_path}` : `${IMG_BASE}${r.backdrop_path}`;
              return (
                <button
                  key={`${r.media_type}-${r.id}`}
                  onClick={() => setSelected(r)}
                  className="relative overflow-hidden rounded-md group focus:outline-none"
                >
                  <img src={src} alt={r.name || r.title} className="w-full aspect-[2/3] object-cover transition-transform duration-300 group-hover:scale-105" loading="lazy" />
                  <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/90 to-transparent p-2 pt-6 text-left">
                    <div className="text-sm font-medium truncate">{r.name || r.title}</div>
                    <div className="text-[11px] text-white/60 uppercase">{r.media_type}</div>
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      </div>

      <MovieModal item={selected} onClose={() => setSelected(null)} />
    </div>
  );
};

export default Search;
